var React = require('react');

function ArrowRoundedUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1"},React.createElement("g",{"stroke":"#142B6F","strokeWidth":"2.25"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M0.5,4.5010929 L15.3845268,4.5010929 L0.5,4.5010929 Z M15.3845268,4.5 L11.362069,0.56557377 L15.3845268,4.5 Z M15.3845268,4.5 L11.362069,8.43442623 L15.3845268,4.5 Z","transform":"translate(-905.000000, -652.000000) translate(135.000000, 530.000000) translate(0.000000, 118.000000) translate(776.000000, 12.500000) scale(1, -1) rotate(90.000000) translate(-776.000000, -12.500000) translate(768.000000, 8.000000)"})))))));
}

ArrowRoundedUp.defaultProps = {"width":"12","height":"18","version":"1.1","viewBox":"0 0 12 18"};

module.exports = ArrowRoundedUp;

ArrowRoundedUp.default = ArrowRoundedUp;
